import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

import { AppConfigService } from "../app-config.service.service";

@Injectable({
  providedIn: "root",
})
export class EstimateService {

  private BaseURI = "";//`${environment.apiUrl}`;
  apiroute = "/FlexIntegration";

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.BaseURI = this.appConfigService.apiBaseUrl;
  }

  GetEstimatesFilter() {
    this.BaseURI = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(
      this.BaseURI + "/Estimates/GetEstimatesFilter",
      {}
    );
  }


  GetEstimates(obj) {
    const a = {
      pageindex: 1,
      pagesize: 20,
      estimateid: 0,
      projectname: "",
      categoryids: "",
      verticalmarketids: "",
      orderid: 0,
      statusids: "",
    };
    return this.http.post<any>(this.BaseURI + "/Estimates", obj);
  }

  GetEstimateAreaSystemDetail(id) {
    let model = {
      method: "GetEstimateAreaSystemDetailCE",
      systemid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  } 

  GetECOMMEstimateAreaSystemDetailCE(id) {
    let model = {
      method: "GetECOMMEstimateAreaSystemDetailCE",
      systemid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateAreaSystemDetailMaster(id) {
    let model = {
      method: "GetEstimateAreaSystemDetailCEMaster",
      systemid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateAreaSystemDetailwithOutPrice(id) {
    let model = {
      method: "GetSystemDetailList",
      systemid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateAreaSystemDetailwithServiceContract(id) {
    let model = {
      method: "Get_EstimatesSystemDetailSC",
      systemid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateValves(id) {
    let model = {
      method: "Get_EstimateValves",
      estimateid: id
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetModuleID(modulename) {
    let model = {
      method: "Get_ModuleIdByModuleName",
      modulename: modulename
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateSystemLibraryStartPageCE() {
    let model = {
      method: "Get_EstimateSystemLibraryStartPageCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  GetEstimateDampers(id) {
    let model = {
      method: "Get_EstimateDampers",
      estimateid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateVAV(id) {
    let model = {
      method: "Get_EstimateVAV",
      estimateid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_Estimates_MaterialList(id) {
    let model = {
      method: "Get_Estimates_MaterialList",
      estimateid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }
  GetEstimateDfaultValues() {
    let model = {
      method: "GetEstimateDfaultValues",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_Estimates_LaborSumary(id) {
    let model = {
      method: "Get_Estimates_LaborSumary",
      estimateid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimatesSC_LaborSumary(id) {
    let model = {
      method: "Get_EstimatesSC_LaborSumary",
      estimateid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_NeworkArea(id) {
    let model = {
      method: "Get_EstimatesNetworkCE",
      estimateid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_Estimate_ReportList(id) {
    let model = {
      method: "Get_Estimate_ReportList",
      estimateid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Get_SC_ReportList(id) {
    let model = {
      method: "Get_SC_ReportList",
      estimateid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Get_Estimate_ReportListCommissioning(id) {
    let model = {
      method: "Get_Estimate_ReportList",
      estimateid: id,
      treeid: 8,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateDocumentControl(estimateid, systemid) {
    let model = {
      method: "Get_EstimateDocumentControl",
      estimateid: estimateid,
      systemid: systemid
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateDocumentControlSsytem(estimateid, systemid) {
    let model = {
      method: "Get_EstimateDocumentControlBySystem",
      estimateid: estimateid,
      systemid: systemid
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  DeleteDocumentControl(id) {
    let model = {
      method: "Delete_EstimateDocumentControl",
      id: id
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_Taxs() {
    return this.http.post<any>(this.BaseURI + "/FlexIntegration", {
      method: "Get_Taxs",
    });
  }

  Get_EstimatePrice_ReportListCE() {
    return this.http.post<any>(this.BaseURI + "/FlexIntegration", {
      method: "Get_EstimatePrice_ReportListCE",
    });
  }

  Get_EstimatePriceSC_ReportListCE(estimateid) {
    return this.http.post<any>(this.BaseURI + "/FlexIntegration", {
      method: "Get_SC_ReportList",
      estimateid:estimateid
    });
  }


  GetSystemArea(id, viewtypeid = 1) {
    return this.http.post<any>(this.BaseURI + "/FlexIntegration", {
      method: "Get_AreaSystemAllCE2", // Get_AreaSystemAllCE2NyComponentsIds y Get_AreaSystemAllCE2
      estimateid: id,
      viewtypeid: viewtypeid
      //Get_AreaSystemAllCE, Get_AreaSystemAll
    });
  }

  GetSystemAreaClient(id, viewtypeid = 1, dbcode) {
    return this.http.post<any>(this.BaseURI + "/FlexIntegration", {
      method: "Get_ClientAreaSystemAllCE2", // Get_AreaSystemAllCE2NyComponentsIds y Get_AreaSystemAllCE2
      estimateid: id,
      viewtypeid: viewtypeid,
      dbcode: dbcode
      //Get_AreaSystemAllCE, Get_AreaSystemAll
    });
  }

  GetSystemAreaMaster() {
    return this.http.post<any>(this.BaseURI + "/FlexIntegration", {
      method: "Get_MasterAreaSystemAllCE2", // Get_AreaSystemAllCE2NyComponentsIds y Get_AreaSystemAllCE2
      // estimateid: id,
      // viewtypeid: viewtypeid,
      // dbcode: dbcode
      //Get_AreaSystemAllCE, Get_AreaSystemAll
    });
  }

  GetSystemAreaSpanded(id, viewtypeid = 1) {
    return this.http.post<any>(this.BaseURI + "/FlexIntegration", {
      method: "Get_AreaSystemAllCE-2CE",
      estimateid: id,
      viewtypeid: viewtypeid
      //Get_AreaSystemAllCE, Get_AreaSystemAll
    });
  }

  GetSystemLibrary() {
    return this.http.post<any>(this.BaseURI + "/FlexIntegration", {
      method: "Get_EstimateSystemLibrary"
    });
  }


  GetSystemArea2(id, viewtypeid = 1) {
    return this.http.post<any>(this.BaseURI + "/FlexIntegration", {
      method: "Get_AreaSystemAllCE",
      estimateid: id,
      viewtypeid: viewtypeid
      //Get_AreaSystemAllCE, Get_AreaSystemAll
    });
  }

  Get_ProjectRegionID(estimateid) {
    let model = {
      method: "Get_RegionsCE",
      EstimateID: estimateid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetReportDynamic(spname, estimateid) {
    let model = {
      method: spname,
      estimateid: estimateid,
    };
    console.log(model);
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Update_EstimateNetwork(
    name,
    systemid,
    bacadd,
    pnlpower,
    rs485net1from,
    rs485net1to,
    intdevicetype
  ) {
    let model = {
      method: "Update_EstimateNetwork",
      systemid: systemid,
      bacadd: bacadd,
      pnlpower: pnlpower,
      rs485net1from: rs485net1from,
      rs485net1to: rs485net1to,
      intdevicetype: intdevicetype,
      sysname: name == "" ? null : name
    };

    console.log(model)
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Update_EstimatesProjectID(estimateid, regionid) {
    let model = {
      method: "Update_EstimatesProjectID",
      EstimateID: estimateid,
      RegionID: regionid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Reset_ProductivityParts(estimateid) {
    let model = {
      method: "Reset_ProductivityParts ",
      EstimateID: estimateid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Update_ProductivityParts(estimateid) {
    let model = {
      method: "Update_ProductivityParts",
      EstimateID: estimateid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Update_LaborParts(estimateid) {
    let model = {
      method: "Update_LaborParts",
      EstimateID: estimateid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }
  Save_EstmimateMaterialRequest(
    id,
    estimateid,
    needbydate,
    userid,
    notes,
    systemname,
    partid,
    detailid
  ) {
    let model = {
      method: "Save_EstmimateMaterialRequest",
      estimateid: estimateid,
      needbydate: needbydate,
      // userid: userid,
      notes: notes,
      systemname: systemname,
      id: id,
      partid: partid,
      detailid: detailid
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Insert_PurchaseOrdersformEstimating(
    estimateid,
    detailid,
    vendorid
  ) {
    let model = {
      method: "Insert_PurchaseOrdersformEstimating",
      estimateid: estimateid,
      detailid: detailid,
      vendorid: vendorid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateRevision(id) {
    let model = {
      method: "Get_EstimateRevision",
      estimateid: id,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateInfo(id, typeid) {
    let model = {
      method: "GetEstimateInfoCE2",
      estimateid: id,
      calctypid: typeid
    }; //GetEstimateInfoCE2, GetEstimateInfoCE, GetEstimateInfo,

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateInfoSC(id, typeid) {
    let model = {
      method: "GetEstimateInfoServiceAgreement",
      estimateid: id,
      calctypid: typeid
    }; //GetEstimateInfoCE2, GetEstimateInfoCE, GetEstimateInfo,

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateExpenses(id) {
    let model = {
      method: "Get_EstimateExpenses",
      estimateid: id,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }
  

  Insert_EstimateFilePathtoUser(userid, filepath) {
    let model = {
      method: "Insert_EstimateFilePathtoUser",
      // userid: userid,
      filepath: filepath
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimatePriceSummary(id, typeid) {
    let model = {
      method: "Get_EstimatePriceSummaryCE-2", //Get_EstimatePriceSummaryCE-2, Get_EstimatePriceSummaryCE
      estimateid: id,
      calctypid: typeid
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimatePriceSummarySC(id, typeid) {
    let model = {
      method: "Get_EstimatePriceSummaryServAgreement", //Get_EstimatePriceSummaryCE-2, Get_EstimatePriceSummaryCE
      estimateid: id,
      calctypid: typeid
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Upadte_EstimateAreaSystemSOPCE(systemid, sop) {
    let model = {
      method: "Upadte_EstimateAreaSystemSOPCE",
      systemid: systemid,
      sop: sop
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Upadte_EstimateAreaSystemCE(
    id,
    systemid,
    sort,
    areaname,
    systemname,
    qty,
    systemtype,
    inactive,
    deleted,
    scopeofwork,
    sop,
    excludefromsearch,
    controldwgname,
    controldwgimg,
    tagtext,
    tagnum,
    description
  ) {
    let model = {
      method: "Upadte_EstimateAreaSystemCE-1",
      id: id,
      systemid: systemid,
      sort: sort,
      areaname: areaname,
      systemname: systemname,
      qty: qty,
      systemtype: systemtype,
      inactive: inactive,
      deleted: deleted,
      scopeofwork: scopeofwork,
      sop: sop,
      excludefromsearch: excludefromsearch,
      controldwgname: controldwgname,
      controldwgimg: controldwgimg == null ? "null" : controldwgimg,
      tagtext: tagtext,
      tagnum: tagnum,
      description: description,
    };
    console.log(model)

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Upadte_EstimateAreaSystemCEAreaid(
    id,
    systemid,
    sort,
    areaname,
    areaid,
    systemname,
    qty,
    systemtype,
    inactive,
    deleted,
    scopeofwork,
    sop,
    excludefromsearch,
    controldwgname,
    controldwgimg,
    tagtext,
    tagnum,
    description
  ) {
    let model = {
      method: "Upadte_EstimateAreaSystemCESingle",
      id: id,
      systemid: systemid,
      sort: sort,
      areaname: areaname,
      areaid:areaid,
      systemname: systemname,
      qty: qty,
      systemtype: systemtype,
      inactive: inactive,
      deleted: deleted,
      scopeofwork: scopeofwork,
      sop: sop,
      excludefromsearch: excludefromsearch,
      controldwgname: controldwgname,
      controldwgimg: controldwgimg == null ? "null" : controldwgimg,
      tagtext: tagtext,
      tagnum: tagnum,
      description: description,
    };
    console.log(model)

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateAreaSystemDetailEditMultCE(systemid, detailid) {
    let model = {
      method: "GetEstimateAreaSystemDetailEditMultCE-1",
      systemid: systemid,
      detailid: detailid,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetECOMMEstimateAreaSystemDetailEditMultCE(systemid, detailid) {
    let model = {
      method: "GetECOMMEstimateAreaSystemDetailEditMultCE-1",
      systemid: systemid,
      detailid: detailid,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateSCAreaSystemDetailEditMultCE(systemid, detailid) {
    let model = {
      method: "GetEstimateAreaSystemDetailEditMultServ",
      systemid: systemid,
      detailid: detailid,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateAreaSystemInfoCE(id) {
    let model = {
      method: "GetEstimateAreaSystemInfoMultCE",
      systemid: id,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  updateEstimateRevisionAreaSystemDetailCE(
    id,
    notes,
    systemid,
    partid,
    partcost,
    applicationnotes,
    applicationnotes1,
    applicationnotes2,
    qty,
    tag,
    pointnumber,
    deleted,
    punique,
    pgprefixed,
    pointtypeid
  ) {
    let model = {
      method: "update_EstimateRevisionAreaSystemDetailCE",
      id: id,
      notes: notes,
      systemid: systemid,
      partid: partid,
      partcost: partcost,
      applicationnotes: applicationnotes,
      applicationnotes1: applicationnotes1,
      applicationnotes2: applicationnotes2,
      qty: qty,
      tag: tag,
      pointnumber: pointnumber,
      deleted: deleted,
      punique: punique,
      pgprefixed: pgprefixed,
      pointtypeid: pointtypeid,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  update_ECOMMEstimateRevisionAreaSystemDetailCE(
    id,
    notes,
    systemid,
    partid,
    partcost,
    applicationnotes,
    applicationnotes1,
    applicationnotes2,
    qty,
    tag,
    pointnumber,
    deleted,
    punique,
    pgprefixed,
    pointtypeid
  ) {
    let model = {
      method: "update_ECOMMEstimateRevisionAreaSystemDetailCE",
      id: id,
      notes: notes,
      systemid: systemid,
      partid: partid,
      partcost: partcost,
      applicationnotes: applicationnotes,
      applicationnotes1: applicationnotes1,
      applicationnotes2: applicationnotes2,
      qty: qty,
      tag: tag,
      pointnumber: pointnumber,
      deleted: deleted,
      punique: punique,
      pgprefixed: pgprefixed,
      pointtypeid: pointtypeid,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  updateEstimateRevisionAreaSystemDetailCE2(
    id,
    notes,
    systemid,
    partid,
    partcost,
    applicationnotes,
    applicationnotes1,
    applicationnotes2,
    qty,
    tag,
    pointnumber,
    deleted,
    punique,
    pgprefixed,
    pointtypeid
  ) {
    let model = {
      method: "update_EstimateRevisionAreaSystemDetail2",
      id: id,
      notes: notes,
      systemid: systemid,
      partid: partid,
      partcost: partcost,
      applicationnotes: applicationnotes,
      applicationnotes1: applicationnotes1,
      applicationnotes2: applicationnotes2,
      qty: qty,
      tag: tag,
      pointnumber: pointnumber,
      deleted: deleted,
      punique: punique,
      pgprefixed: pgprefixed,
      pointtypeid: pointtypeid,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  updateEstimateRevisionAreaSystemDetailCEFactor(
    id,
    notes,
    systemid,
    partid,
    partcost,
    applicationnotes,
    applicationnotes1,
    applicationnotes2,
    qty,
    tag,
    pointnumber,
    deleted,
    punique,
    pgprefixed,
    pointtypeid,
    QtyFactor
  ) {
    let model = {
      method: "update_EstimateRevisionAreaSystemDetailCE",
      id: id,
      notes: notes,
      systemid: systemid,
      partid: partid,
      partcost: partcost,
      applicationnotes: applicationnotes,
      applicationnotes1: applicationnotes1,
      applicationnotes2: applicationnotes2,
      qty: qty,
      tag: tag,
      pointnumber: pointnumber,
      deleted: deleted,
      punique: punique,
      pgprefixed: pgprefixed,
      pointtypeid: pointtypeid,
      qtyfactor:QtyFactor
    };
    console.log(model)
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  updateEstimateRevisionAreaSystemDetailCEFactorWithIO(
    id,
    notes,
    systemid,
    partid,
    partcost,
    applicationnotes,
    applicationnotes1,
    applicationnotes2,
    qty,
    tag,
    pointnumber,
    deleted,
    punique,
    pgprefixed,
    pointtypeid,
    QtyFactor,
    iowiredto,
    ctrlTerminal
  ) {
    let model = {
      method: "update_EstimateRevisionAreaSystemDetailCE",
      id: id,
      notes: notes,
      systemid: systemid,
      partid: partid,
      partcost: partcost,
      applicationnotes: applicationnotes,
      applicationnotes1: applicationnotes1,
      applicationnotes2: applicationnotes2,
      qty: qty,
      tag: tag,
      pointnumber: pointnumber,
      deleted: deleted,
      punique: punique,
      pgprefixed: pgprefixed,
      pointtypeid: pointtypeid,
      qtyfactor:QtyFactor,
      iowiredto:iowiredto,
      ctrlterminal:ctrlTerminal
    };
    console.log(model)
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  updateEditMultiplePartsSC(
    id,
    notes,
    systemid,
    partid,
    partcost,
    applicationnotes,
    applicationnotes1,
    applicationnotes2,
    qty,
    tag,
    pointnumber,
    deleted,
    punique,
    pgprefixed,
    pointtypeid,
    QtyFactor,
    iowiredto
  ) {
    let model = {
      method: "Insert_EstimateAreaSystemDetailsSingleSC",
      id: id,
      notes: notes,
      systemid: systemid,
      partid: partid,
      partcost: partcost,
      qty: qty,
      punique: punique == true ? 1 : 0,
      qtyfactor:QtyFactor,
      iowiredto:iowiredto
    };
    console.log(model)
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }



  Get_Estimates_findandreplace(id) {
    let model = {
      method: "Get_Estimates_findandreplace",
      estimateid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_AccParts(val) {
    let model = {
      method: "Get_AccParts",
      partnamefilter: val,
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_AccPartsNew(val) {
    let model = {
      method: "Get_AccParts",
      partnamefilter: val,
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_LaborParts(val) {
    let model = {
      method: "Get_LaborParts",
      partnamefilter: val,
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_AccPartsMaster(val) {
    let model = {
      method: "Get_AccPartsMaster",
      partnamefilter: val,
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_AccPartsKit(val) {
    let model = {
      method: "Get_AccPartsKit",
      partnamefilter: val,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_AccPartsTop(val) {
    let model = {
      method: "Get_AccPartsTop",
      partnamefilter: val,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_AccPartsTopMaster(val) {
    let model = {
      method: "Get_AccPartsTopMaster",
      partnamefilter: val,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateListNavAll(val, estimateID = null) {
    let model = {
      method: "Get_EstimateListNavAll",
      astimateName: val,
      estimateID: estimateID
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateListShop(val, estimateID = null) {
    let model = {
      method: "Get_EstimateListNavAll",
      astimateName: val,
      estimateID: estimateID
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateListNavAllClient(val, estimateID = null, dbcode) {
    console.log("🚀 ~ EstimateService ~ Get_EstimateListNavAllClient ~ val:", val)
    console.log("🚀 ~ EstimateService ~ Get_EstimateListNavAllClient ~ estimateID:", estimateID)
    console.log("🚀 ~ EstimateService ~ Get_EstimateListNavAllClient ~ dbcode:", dbcode)
    let model = {
      method: "Get_ClientEstimateListNavAll",
      astimateName: val,
      estimateID: estimateID,
      dbcode: dbcode
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateListNavAllMaster(val, estimateID = null) {
    let model = {
      method: "Get_EstimateListNavAllMaster",
      astimateName: val,
      estimateID: estimateID
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateListCubeBox(val, estimateID = null) {
    let model = {
      method: "Get_CubeBox_EstimateList",
      astimateName: val,
      estimateID: estimateID
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }



  Insert_CreateSOVfroestimateCE(val) {
    let model = {
      method: "Insert_CreateSOVfroestimateCE",
      estimateid: val,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }



  Insert_CreatesowfroestimateCE(id) {
    let model = {
      method: "Insert_CreatesowfroestimateCE",
      estimateid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Update_EstimatePartCostCE(id, detailid) {
    let model = {
      method: "Update_EstimatePartCostCE",
      estimateid: id,
      detailid: detailid
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Update_EstimatePartCostSC(id, detailid) {
    let model = {
      method: "UpdateServiceContractSystemDetailCurrentCost",
      estimateid: id,
      detailid: detailid
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Update_EstimateComponentsCE(id) {
    let model = {
      method: "Update_EstimateComponentsCE",
      estimateid: id,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  UpadteEstimatePartFindandReplaceCE(estimateid, tofind, toreplace, detailid) {
    let model = {
      method: "UpadteEstimatePartFindandReplaceCE",
      estimateid: estimateid,
      parttofindid: tofind,
      parttoreplaceid: toreplace,
      detailid: detailid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateAreaSystemComponentsCE(systemid) {
    let model = {
      method: "GetEstimateAreaSystemComponentsCE",
      systemid: systemid,
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEcomAreaSystemComponentsCE(systemid) {
    let model = {
      method: "GetEcomAreaSystemComponentsCE",
      systemid: systemid,
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateAreaSystemComponentsCEVisio(systemid) {
    let model = {
      method: "GetEstimateAreaSystemComponentsCEDiagram",
      systemid: systemid,
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateAreaSystemComponentsCEDiagram_SCV2(systemid) {
    let model = {
      method: "GetEstimateAreaSystemComponentsCEDiagram_SCV2",
      systemid: systemid,
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetECOMMEstimateAreaSystemComponentsCEDiagram_SCV2(systemid) {
    let model = {
      method: "GetECOMMEstimateAreaSystemComponentsCEDiagram_SCV2",
      systemid: systemid,
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetEstimateAreaSystemComponentsCENewTag(systemid) {
    let model = {
      method: "GetEstimateAreaSystemComponentsCE_SCV2",
      systemid: systemid,
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetECOMMEstimateAreaSystemComponentsCE_SCV2(systemid) {
    let model = {
      method: "GetECOMMEstimateAreaSystemComponentsCE_SCV2",
      systemid: systemid,
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Update_EstmateSVG(ids, typeid) {
    let model = {
      method: "Update_EstmateSVG",
      ids: ids,
      typeid: typeid
    };

    console.log(model)

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateLibComponentsTreeCE() {
    let model = {
      method: "Get_EstimateLibComponentsTreeCE",
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateLibComponentsTreeCECR() {
    let model = {
      method: "Get_EcomComponentsTreeCE",
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateLibComponentsTreeCE2() {
    let model = {
      method: "Get_EstimateLibComponentsTreeCEWithMaster",
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateLibComponentsTreeCE2Client(dbcode) {
    let model = {
      method: "Get_ClientEstimateLibComponentsTree",
      dbcode: dbcode
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Get_EstimateLibComponentsTreeCEMaster(active = 0) {
    let model = {
      method: "Get_EstimateLibComponentsTreeCEMaster",
      all: active
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  } 

  

  Get_EstimateLibComponentsTypesTreeCE() {
    let model = {
      method: "Get_EstimateLibComponentsTypesTreeCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  } 

  Get_EstimateLibComponentsMasterMenuCE() {
    let model = {
      method: "Get_EstimateLibComponentsMasterMenuCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateSystemComponentDetailsCE(systemid) {
    let model = {
      method: "Get_EstimateSystemComponentDetailsCE",
      systemid: systemid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EcomSystemComponentDetailsCE(systemid) {
    let model = {
      method: "Get_EcomSystemComponentDetailsCE",
      systemid: systemid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Get_EstimateSystemComponentDetailsCE_SCV2(systemid) {
    let model = {
      method: "Get_EstimateSystemComponentDetailsCE_SCV2",
      systemid: systemid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_ECOMMEstimateSystemComponentDetailsCE_SCV2(systemid) {
    let model = {
      method: "Get_ECOMMEstimateSystemComponentDetailsCE_SCV2",
      systemid: systemid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Insert_EstimateRevisionAreaSystemDetailCE(systemid, componentids) {
    let model = {
      method: "Insert_EstimateRevisionAreaSystemDetail",
      systemid: systemid + "-1",
      componentids: componentids,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Insert_EstimateRevisionAreaSystemDetailCE2(systemid, componentids) {
    console.log(componentids)

    const arrayOriginal = componentids.split(',');
    const arrayUnico = [];

    for (let i = 0; i < arrayOriginal.length; i++) {
      if (!arrayUnico.includes(arrayOriginal[i])) {
        arrayUnico.push(arrayOriginal[i]);
      }
    }

    const stringUnico = arrayUnico.join(',');

    console.log(stringUnico)
    // let data
    let model = {
      method: "Update_EstimateRevisionAreaSystemDetailFromWebDiagram",
      systemid: systemid + "-1",
      componentids: stringUnico,
    };

    console.log("dataFinal",model)

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Insert_EstimateRevisionAreaSystemDetailCE2_SCV2(systemid, componentids) {
    console.log(componentids)

    const arrayOriginal = componentids.split(',');
    const arrayUnico = [];

    for (let i = 0; i < arrayOriginal.length; i++) {
      if (!arrayUnico.includes(arrayOriginal[i])) {
        arrayUnico.push(arrayOriginal[i]);
      }
    }

    const stringUnico = arrayUnico.join(',');

    console.log(stringUnico)
    // let data
    let model = {
      method: "Update_EstimateRevisionAreaSystemDetailFromWebDiagram_SCV2",
      systemid: systemid + "-1",
      componentids: stringUnico,
    };

    console.log("dataFinal",model)

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Update_ECOMM_EstimateRevisionAreaSystemDetailFromWebDiagram_SCV2(systemid, componentids) {
    console.log(componentids)

    const arrayOriginal = componentids.split(',');
    const arrayUnico = [];

    for (let i = 0; i < arrayOriginal.length; i++) {
      if (!arrayUnico.includes(arrayOriginal[i])) {
        arrayUnico.push(arrayOriginal[i]);
      }
    }

    const stringUnico = arrayUnico.join(',');

    console.log(stringUnico)
    // let data
    let model = {
      method: "Update_ECOMM_EstimateRevisionAreaSystemDetailFromWebDiagram_SCV2",
      systemid: systemid + "-1",
      componentids: stringUnico,
    };

    console.log("dataFinal",model)

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Insert_EstimateRevisionAreaSystemDetailCE3(systemid, componentids) {
    let model = {
      method: "insert_EstimateRevisionAreaSystemDetail2",
      systemid: systemid + "-1",
      componentids: componentids,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Insert_ECOMMEstimateRevisionAreaSystemDetail2(systemid, componentids) {
    let model = {
      method: "Insert_ECOMMEstimateRevisionAreaSystemDetail2",
      systemid: systemid + "-1",
      componentids: componentids,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  insert_EcomRevisionAreaSystemDetail2(systemid, componentids) {
    let model = {
      method: "insert_EcomRevisionAreaSystemDetail2",
      systemid: systemid + "-1",
      componentids: componentids,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }
  

  Delete_EstimateSystemComponentCE(systemid, componentids, instatid) {
    let model = {
      method: "Delete_EstimateSystemComponentCE",
      systemid: systemid,
      componentid: componentids,
      instatid: instatid,
    };

    console.log(model)

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  DeletEcomSystemComponentCE(systemid, componentids, instatid) {
    let model = {
      method: "DeletEcomSystemComponentCE",
      systemid: systemid,
      componentid: componentids,
      instatid: instatid,
    };

    console.log(model)

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Insert_EstimateCreateNewSystemCE(
    id,
    systemid,
    sort,
    areaname,
    systemname,
    qty,
    systemtype,
    inactive,
    deleted,
    scopeofwork,
    sop,
    excludefromsearch,
    controldwgname,
    controldwgimg,
    tagtext,
    tagnum,
    description
  ) {
    let model = {
      method: "Insert_EstimateCreateNewSystemCE",
      id: id,
      systemid: systemid,
      sort: sort,
      areaname: areaname,
      systemname: systemname,
      qty: qty,
      systemtype: systemtype,
      inactive: inactive,
      deleted: deleted,
      scopeofwork: scopeofwork,
      sop: sop,
      excludefromsearch: excludefromsearch,
      controldwgname: controldwgname,
      controldwgimg: controldwgimg,
      tagtext: tagtext,
      tagnum: tagnum,
      description: description,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Insert_EstimateAreaCE(estimateid, name, id = 0, sort, inactive) {
    let model = {
      method: "Insert_EstimateAreaCE",
      estimateid: estimateid,
      name: name,
      id: id,
      sort: sort,
      inactive: !inactive
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_Estimates_MaterialListVendor(estimateid) {
    let model = {
      method: "Get_Estimates_MaterialListVendor",
      estimateid: estimateid,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Get_EstimateSystemLibrary(
    systemid,
    systemtypeID,
    partid,
    verticalmarketid,
    inputappnotes,
    islibrary,
    projectname,
    systemname,
    projectbidstatusid,
    outputappnotes,
    tagids,
    designerids,
    estimateid
  ) {
    let model = {
      method: "Get_EstimateSystemLibraryTreeCE",
      // Get_EstimateSystemLibraryTreeCE, Get_EstimateSystemLibraryCE
      systemid: systemid,
      systemtypeID: systemtypeID,
      partid: partid,
      verticalmarketid: verticalmarketid,
      inputappnotes: inputappnotes,
      islibrary: islibrary,
      projectname: projectname,
      systemname: systemname,
      projectbidstatusid: projectbidstatusid,
      outputappnotes: outputappnotes,
      tagids: tagids,
      designerids: designerids,
      estimateid: estimateid,

      // "serviceid": 0,
      // "siteid": 2976,
      // "requestedbyid": 1,
      // "customerpo": "new test in DB",
      // "requestdate": "2017-11-16T08:00:00-05:00",
      // "callahead": 0,
      // "serviceconfirmed": 0,
      // "priorityid": 2,
      // "projectid": 1670,
      // "servicetype": 5,
      // "servicecategoryid": 1,
      // "userid": 1,
      // "resources": 1,
      // "serviceestimatedhours": 1,
      // "scheduledate": "2017-11-16T08:00:00-05:00",
      // "statusid": 1,
      // "reasonforservice": "test in DB"
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateDesignerList() {
    let model = {
      method: "Get_EstimateDesignerList",
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  DuplicateSystemSingle(areaid, systemid) {
    let model = {
      method: "DuplicateSystemSingle",
      areaid: areaid,
      systemid: systemid,
    };
    console.log(model)
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  DuplicateSystemSingleNetwork(areaid, systemid) {
    let model = {
      method: "DuplicateSystemSingle_Net",
      systemid: systemid,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  ReplicateeEstimateSystems(systemid, totalsystem) {
    let model = {
      method: "ReplicateeEstimateSystems",
      totalsystem: totalsystem,
      systemid: systemid,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateScheduleOfValuesCE(estimateid) {
    let model = {
      method: "Get_EstimateScheduleOfValuesCE",
      estimateid: estimateid,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstDrawingList(estimateid) {
    let model = {
      method: "Get_EstDrawingList",
      estimateid: estimateid,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_UserFilePath(userid) {
    let model = {
      method: "Get_UserFilePath",
      // userid: userid,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_GetDocumentTypesCE() {
    let model = {
      method: "Get_GetDocumentTypesCE",
      // userid: userid,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  UpdateDrwingList(
    id,
    estimateid,
    pagetitle,
    pagerevision,
    pageindex,
    pagedrawingnumber,
    pageheader,
    pagesource,
    pagesourcetype,
    pageactive,
    pagesourcename,
    pagesourcesystemname,
    pagesourcepath,
    drawingtypeid
  ) {
    let model = {
      method: "UpdateDrwingList",
      id: id,
      estimateid: estimateid,
      pagetitle: pagetitle,
      pagerevision: pagerevision,
      pageindex: pageindex,
      pagedrawingnumber: pagedrawingnumber,
      pageheader: pageheader,
      pagesource: pagesource,
      pagesourcetype: pagesourcetype,
      pageactive: pageactive,
      pagesourcename: pagesourcename,
      pagesourcesystemname: pagesourcesystemname,
      pagesourcepath: pagesourcepath,
      drawingtypeid: drawingtypeid
    };

    console.log(model)

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  UpdateEstimatesInfo(
    EstimateID,
    ProjectID,
    EstDate,
    ProfitMargin,
    OverHead,
    TaxID,
    LaborRisk,
    Freight,
    Warranty,
    RegionID,
    NotForConstruction,
    estimatename
  ) {
    let model = {
      method: "Update_Estimates",
      EstimateID: EstimateID,
      ProjectID: ProjectID,
      EstDate: EstDate,
      ProfitMargin: ProfitMargin,
      OverHead: OverHead,
      TaxID: TaxID,
      LaborRisk: LaborRisk,
      Freight: Freight,
      Warranty: Warranty,
      RegionID: RegionID,
      NotForConstruction: NotForConstruction,
      EstimateName: estimatename
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  UpdateEstimatesInfoSC(
    EstimateID,
    ProjectID,
    EstDate,
    ProfitMargin,
    OverHead,
    TaxID,
    LaborRisk,
    Freight,
    Warranty,
    RegionID,
    NotForConstruction,
    estimatename,
    filename
  ) {
    let model = {
      method: "Update_EstimatesService",
      EstimateID: EstimateID,
      ProjectID: ProjectID,
      EstDate: EstDate,
      ProfitMargin: ProfitMargin,
      OverHead: OverHead,
      TaxID: TaxID,
      LaborRisk: LaborRisk,
      Freight: Freight,
      Warranty: Warranty,
      RegionID: RegionID,
      NotForConstruction: NotForConstruction,
      EstimateName: estimatename,
      siteimage:filename
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }



  GetUpdateEstimateExpensive(
    id, estid, expenseid, expenseqty, expenseamount, expenseprofit
  ) {
    let model = {
      method: "Get_UpdateEstimateExpensive",
      id: id,
      estid: estid,
      expenseid: expenseid,
      expenseqty: expenseqty,
      expenseamount: expenseamount,
      expenseprofit: expenseprofit,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetUpdateEstimateExpensiveNew(
    id, estid, expenseid, expenseqty, expenseamount, expenseprofit, expensedescription
  ) {
    let model = {
      method: "Get_UpdateEstimateExpensive",
      id: id,
      estid: estid,
      expenseid: expenseid,
      expenseqty: expenseqty,
      expenseamount: expenseamount,
      expenseprofit: expenseprofit,
      expensedescription:expensedescription
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Update_EstimatesSellPrice(estimateid, price, typeid) {
    let model = {
      method: "Update_EstimatesSellPrice",
      estid: estimateid,
      estprice: price,
      calctypid: typeid
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Update_EstimatesSellPriceNew(estimateid, price, typeid) {
    let model = {
      method: "Update_EstimatesSellPrice2",
      estid: estimateid,
      estprice: price,
      calctypid: typeid
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  InsertCreateSOVfroestimateCE(
    estimateid, userid
  ) {
    let model = {
      method: "Get_UpdateEstimateExpensive",
      estimateid: estimateid,
      // userid: userid,
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  InsertEstimate(projectid, labor, freigt, warranty, overhead, proffitmargin, createdby) {
    let model = {
      method: "Insert_Estimate",
      projectid: projectid,
      // userid: userid,
      typeid: 0, // Porque ya el proyecto se crea desde el frontend
      labor: labor,
      freigt: freigt,
      warranty: warranty,
      overhead: overhead,
      proffitmargin: proffitmargin,
      createdby: createdby,
    };

    console.log(model)

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  InsertEstimateWithTax(projectid, labor, freigt, warranty, overhead, proffitmargin, createdby,taxid, regionid) {
    let model = {
      method: "Insert_Estimate",
      projectid: projectid,
      // userid: userid,
      typeid: 0, // Porque ya el proyecto se crea desde el frontend
      laborRisk: labor,
      freigt: freigt,
      warranty: warranty,
      overhead: overhead,
      proffitmargin: proffitmargin,
      createdby: createdby,
      taxid:taxid,
      regionid:regionid
    };

    console.log(model)
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Upatade_EstimateLaborSummaryCE(id, active, partcost, partid, pointtypeid, pointype, detailqty, systemqty, punique, systemid, systemSort, detailid,) {
    let model = {
      method: "Upatade_EstimateLaborSummaryCE",
      id: id,
      active: active,
      partcost: partcost,
      partid: partid,
      pointtypeid: pointtypeid,
      pointype: pointype,
      detailqty: detailqty,
      systemqty: systemqty,
      systemid: systemid,
      punique: punique,
      systemSort: systemSort,
      detailid: detailid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Upatade_SCEstimateLaborSummaryCE(id, active, partcost, partid, pointtypeid, pointype, detailqty, systemqty, punique, systemid, systemSort, detailid,) {
    let model = {
      method: "Upatade_EstimateLaborSummaryService",
      id: id,
      active: active,
      partcost: partcost,
      partid: partid,
      pointtypeid: pointtypeid,
      pointype: pointype,
      detailqty: detailqty,
      systemqty: systemqty,
      systemid: systemid,
      punique: punique,
      systemSort: systemSort,
      detailid: detailid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }



  Insert_AreaDuplicate(areaid, newestimateid) {
    let model = {
      method: "Insert_AreaDuplicate",
      areaid: areaid,
      newestimateid: newestimateid
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  DeleteSystem(systemid) {
    let model = {
      method: "Delete_EstimateAreaSystemCE",// ,
      systemid: systemid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  DeleteArea(areaid) {
    let model = {
      method: "Delete_EstimateAreaCE",
      areaid: areaid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimatesAll() {
    let model = {
      method: "Get_EstimatesAll",
      // tsdate: date
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_ServiceContractsAll() {
    let model = {
      method: "Get_ServiceContractsAll",
      // tsdate: date
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_ServiceContractsAllFilter(filter) {
    let model = {
      method: "Get_ServiceContractsAll",
      filter: filter
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Insert_EstimateDuplicate(estimateid) {
    let model = {
      method: "Insert_EstimateDuplicate",
      estimateid: estimateid
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }



  DeleteEstimate(id) {
    let model = {
      method: "Delete_Estimate",
      id: id
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Save_DuplicateComponentCE(id) {
    let model = {
      method: "Save_DuplicateComponentCE",
      id: id
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Save_DuplicateComponentCEMaster(id) {
    let model = {
      method: "Save_DuplicateComponentCEMaster",
      id: id
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Save_DuplicateSystemTypeComponentCE(id) {
    let model = {
      method: "Duplicate_ComponentTypeCE",
      id: id
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Save_DuplicateSystemTypeComponentCEMaster(id) {
    let model = {
      method: "Duplicate_ComponentTypeCEMaster",
      id: id
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_Estimates_MaterialListParts(estimateid, vendorid) {
    let model = {
      method: "Get_Estimates_MaterialListParts",
      vendorid: vendorid,
      estimateid: estimateid
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Insert_EstimateAreaSystemDetails(qty, partnumber, applicationnotes1, tag, pointype, pointnumber, systemid, partcost) {
    let model = {
      method: "Insert_EstimateAreaSystemDetailsImportCE",
      qty: qty,
      partnumber: partnumber,
      applicationnotes1: applicationnotes1,
      tag: tag,
      pointype: pointype,
      pointnumber: pointnumber,
      systemid: systemid,
      id: 0,
      damper: 0,
      VALVE: 0,
      partcost: partcost
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Insert_EstimateAreaSystemDetailsSingleCE(qty, partnumber, applicationnotes1, tag, pointype, pointnumber, systemid, partcost, applicationnotes2, partid, id, notes, Unique) {
    let model = {
      method: "Insert_EstimateAreaSystemDetailsSingleCE",
      qty: qty,
      partnumber: partnumber,
      applicationnotes1: applicationnotes1,
      tag: tag,
      pointype: pointype,
      pointtypeid: pointype,
      pointnumber: pointnumber,
      systemid: systemid,
      id: id,
      damper: 0,
      VALVE: 0,
      partcost: partcost,
      applicationnotes2: applicationnotes2,
      partid: partid,
      notes: notes,
      punique: Unique == true ? 1 : 0
    };
    console.log(model)
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateAreaSystemDetailsImportCE(partnumber, applicationnotes1, pointype) {
    let model = {
      method: "Get_EstimateAreaSystemDetailsImportCE",
      partnumber: partnumber,
      applicationnotes1: applicationnotes1,
      pointype: pointype,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Upadte_EstimateSystemAreaCE(systemid, areaid, sort) {
    let model = {
      method: "Upadte_EstimateSystemAreaCE",
      areaid: areaid,
      sort: sort,
      systemid: systemid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Update_EstimateSystemDrawingfromlibrary(estimateid, systemid) {
    let model = {
      method: "Update_EstimateSystemDrawingfromlibrary",
      estimateid: estimateid,
      systemid: systemid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateSystemLibDevNetWorkType() {
    let model = {
      method: "Get_EstimateSystemLibDevNetWorkType",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateVAVByIds(ids) {
    let model = {
      method: "Get_EstimateVAVByIds",
      itemids: ids
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateValvesByIds(ids) {
    let model = {
      method: "Get_EstimateValvesByIds",
      itemids: ids
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Get_EstimateExpensetype() {
    let model = {
      method: "Get_EstimateExpensetype",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }
  GetVAVHeatType() {
    let model = {
      method: "GetVAVHeatTypeCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetDamperBladeStyle() {
    let model = {
      method: "GetDamperBladeStyleCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetDamperStyle() {
    let model = {
      method: "GetDamperStyleCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimatePartsDamperActuator() {
    let model = {
      method: "Get_EstimatePartsDamperActuator",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetValveConfigurationCE() {
    let model = {
      method: "GetValveConfigurationCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetMasterValveConfigurationCE() {
    let model = {
      method: "GetMasterValveConfigurationCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetValveActuatorSignal() {
    let model = {
      method: "GetValveActuatorSignalCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetMasterValveActuatorSignalCE() {
    let model = {
      method: "GetMasterValveActuatorSignalCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetMasterValvePower() {
    let model = {
      method: "GetMasterValvePower",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetValvePower() {
    let model = {
      method: "GetValvePowerCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetValveLineSize() {
    let model = {
      method: "GetValveLineSizeCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetValveType() {
    let model = {
      method: "GetValveTypeCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetMasterValveTypeCE() {
    let model = {
      method: "GetMasterValveTypeCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetValveSystemType() {
    let model = {
      method: "GetValveSystemTypeCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetMasterValveSystemTypeCE() {
    let model = {
      method: "GetMasterValveSystemTypeCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetValveSize() {
    let model = {
      method: "GetValveSizeCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetMasterValveSizeCE() {
    let model = {
      method: "GetMasterValveSizeCE",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetMasterValveBody() {
    let model = {
      method: "GetMasterValveBody",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetMasterActuatorPos() {
    let model = {
      method: "GetMasterActuatorPos",
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_UserGridReportSettings(id) {
    let model = {
      method: "Get_UserGridReportSettings",
      reportid: id
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Update_UserGridReportSettings(id, reportid, reportname, filtersettings, visiblecolumns) {
    let model = {
      method: "Update_UserGridReportSettings",
      id: id,
      reportid: reportid,
      reportname: reportname,
      filtersettings: filtersettings,
      visiblecolumns: visiblecolumns,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }





  Update_EstimateVAVByIds(id, location, systemname, vavsize, vavmincoolcfm, vavmaxcoolcfm, vavminheatcfm, vavmaxheatcfm, vavpvt1, vavvolt, vavbaccadd, vavpnlpower, 
    vavrst48netfrom, vavrst48netto, heattypeid, kw, kFactor) {
    let model = {
      method: "Update_EstimateVAVByIds",
      location: location,
      systemname: systemname,
      vavsize: vavsize,
      vavmincoolcfm: vavmincoolcfm,
      vavmaxcoolcfm: vavmaxcoolcfm,
      vavminheatcfm: vavminheatcfm,
      vavmaxheatcfm: vavmaxheatcfm,
      vavpvt1: vavpvt1,
      vavvolt: vavvolt,
      vavbaccadd: vavbaccadd,
      vavpnlpower: vavpnlpower,
      vavrst48netfrom: vavrst48netfrom,
      vavrst48netto: vavrst48netto,
      heattypeid: heattypeid,
      id: id,
      kw:kw,
      kfactor:kFactor
    };
    console.log(model)

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  UpdateMultiple_EstimateDamperByIds(itemids, bladeid, signalid, styleid, powerid, location, w, h, partid,DamperModel, SR, actuator) {
    let model = {
      method: "UpdateMultiple_EstimateDamperByIds",
      itemids: itemids,
      bladeid: bladeid,
      signalid: signalid,
      styleid: styleid,
      powerid: powerid,
      location: location,
      w: w,
      h: h,
      partid: partid,
      dampermodel:DamperModel,
      sr:SR,
      actuator:actuator
    };

    console.log(model)

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  UpdateMultiple_EstimateValvesByIds(itemids, valveacttypeid, valvelinesizeid, valvesystemid, velvetypeid, valvepipecongid, valvesizeid, partid,
    DamperModel,
    VALVEDESCV,
    VALVECV,
    VALVEDESIGNDP,
    VALVEACTUALDP,
    SystemName, 
    VALVEDESGPM,
    tag,
    valveclsoffp = 0,
    sr,
    actfailsafe,
    valveactualgpm
    ) {
    let model = {
      method: "UpdateMultiple_EstimateValvesByIds",
      itemids: itemids,
      valveacttypeid: valveacttypeid,
      valvelinesizeid: valvelinesizeid,
      valvesystemid: valvesystemid,
      velvetypeid: velvetypeid,
      valvepipecongid: valvepipecongid,
      valvesizeid: valvesizeid,
      partid: partid,
      DamperModel:DamperModel,
      SystemName:SystemName,
      valvedescv:VALVEDESCV == undefined ? 0 : VALVEDESCV,
      valvecv:VALVECV == undefined ? 0 : VALVECV,
      valvedesigndp:VALVEDESIGNDP == undefined ? 0 : VALVEDESIGNDP,
      valveactualdp:VALVEACTUALDP == undefined ? 0 : VALVEACTUALDP,
      valvedesigngpm:VALVEDESGPM == undefined ? 0 : VALVEDESGPM,
      valvetag:tag,
      valveclsoffp:valveclsoffp,
      sr:sr == true ? 1 : 0,
      actfailsafe:actfailsafe,
      valveactualgpm:valveactualgpm
    };

    console.log(model)
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  UpdateMultiple_EstimateValvesByIds2(itemids, valveacttypeid, valvelinesizeid, valvesystemid, velvetypeid, valvepipecongid, valvesizeid, partid,
    DamperModel,
    VALVEDESCV,
    VALVECV,
    VALVEDESIGNDP,
    VALVEACTUALDP,
    SystemName, 
    VALVEDESGPM,
    tag,
    valveclsoffp = 0,
    sr,
    actfailsafe,
    valveactualgpm,
    sr2
    ) {
    let model = {
      method: "UpdateMultiple_EstimateValvesByIds",
      itemids: itemids,
      valveacttypeid: valveacttypeid,
      valvelinesizeid: valvelinesizeid,
      valvesystemid: valvesystemid,
      velvetypeid: velvetypeid,
      valvepipecongid: valvepipecongid,
      valvesizeid: valvesizeid,
      partid: partid,
      DamperModel:DamperModel,
      SystemName:SystemName,
      valvedescv:VALVEDESCV == undefined ? 0 : VALVEDESCV,
      valvecv:VALVECV == undefined ? 0 : VALVECV,
      valvedesigndp:VALVEDESIGNDP == undefined ? 0 : VALVEDESIGNDP,
      valveactualdp:VALVEACTUALDP == undefined ? 0 : VALVEACTUALDP,
      valvedesigngpm:VALVEDESGPM == undefined ? 0 : VALVEDESGPM,
      valvetag:tag,
      valveclsoffp:valveclsoffp,
      sr:sr == true ? 1 : 0,
      actfailsafe:actfailsafe,
      valveactualgpm:valveactualgpm,
      valveactfailpos: sr2,
    };

    console.log(model)
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  UpdateMultiple_MasterValvesByIds(itemids, valveacttypeid, valvelinesizeid, valvesystemid, velvetypeid, valvepipecongid, valvesizeid, partid,
    DamperModel,
    VALVEDESCV,
    VALVECV,
    VALVEDESIGNDP,
    VALVEACTUALDP,
    SystemName, 
    VALVEDESGPM,
    tag,
    valveclsoffp = 0,
    sr,
    actfailsafe,
    valveactualgpm,
    valvebody,
    sr2,
    parttorque,
    valvepwr
    ) {
    let model = {
      method: "UpdateMultiple_MasterValves",
      itemids: itemids,
      valveacttypeid: valveacttypeid,
      valvelinesizeid: valvelinesizeid,
      valvesystemid: valvesystemid,
      velvetypeid: velvetypeid,
      valvepipecongid: valvepipecongid,
      valvesizeid: valvesizeid,
      partid: partid,
      DamperModel:DamperModel,
      SystemName:SystemName,
      valvedescv:VALVEDESCV == undefined ? 0 : VALVEDESCV,
      valvecv:VALVECV == undefined ? 0 : VALVECV,
      valvedesigndp:VALVEDESIGNDP == undefined ? 0 : VALVEDESIGNDP,
      valveactualdp:VALVEACTUALDP == undefined ? 0 : VALVEACTUALDP,
      valvedesigngpm:VALVEDESGPM == undefined ? 0 : VALVEDESGPM,
      valvetag:tag,
      valveclsoffp:valveclsoffp,
      sr:sr == true ? 1 : 0,
      actfailsafe:actfailsafe,
      valveactualgpm:valveactualgpm,
      valvebody: valvebody,
      valveactfailpos: sr2,
      parttorque: parttorque,
      valvepwr: valvepwr
    };

    console.log(model)
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Get_EstimateDamperByIds(ids) {
    let model = {
      method: "Get_EstimateDamperByIds",
      itemids: ids
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Get_ProjectPartDetailSugestedValues(partnumber) {
    let model = {
      method: "Get_ProjectPartDetailSugestedValues",
      partnumber: partnumber
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_ProjectPartDetailSugestedValuesMaster(partnumber) {
    let model = {
      method: "Get_ProjectPartDetailSugestedValuesMaster",
      partnumber: partnumber
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateApplicationNotesValues(id) {
    let model = {
      method: "Get_EstimateApplicationNotesValues",
      id: id
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateApplicationNotesValuesMaster(id) {
    let model = {
      method: "Get_EstimateApplicationNotesValuesMaster",
      id: id
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetScopeOfWork(estimateid) {
    let model = {
      method: "GetScopeOfWork",
      estimateid: estimateid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimatesowReport(projectid) {
    let model = {
      method: "Get_EstimatesowReport",
      projectid: projectid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimatesowReportEstimate(projectid,estimateid) {
    let model = {
      method: "Get_EstimatesowReportByEstimateID",
      projectid: projectid,
      estimteid:estimateid
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetProjectQuoteSignature(projectid) {
    let model = {
      method: "GetProjectQuoteSignature",
      projectid: projectid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetProjectQuote(projectid) {
    let model = {
      method: "GetProjectQuote",
      projectid: projectid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  InsertUpdateProjectPartEstDetailSignature(
    id,
    projectid,
    acceptedbyname,
    acceptedbytitle,
    proposedbyname,
    proposedbyttile,
    proposeddate,
    signaturetext1,
    signaturetext2,
    accepteddate,
    estimateid,
    proposedbyid
  ) {
    let model = {
      method: "InsertUpdateProjectPartEstDetailSignature",
      id: id,
      projectid: projectid,
      acceptedbyname: acceptedbyname,
      acceptedbytitle: acceptedbytitle,
      proposedbyname: proposedbyname,
      proposedbyttile: proposedbyttile,
      proposeddate: proposeddate,
      signaturetext1: signaturetext1,
      signaturetext2: signaturetext2,
      accepteddate:accepteddate,
      // estimateid:estimateid
      proposedid:proposedbyid
    };

    console.log(model)
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  UpdateProjectQuoteSignatureApprovals(
    id,
    projectid,
    sowheader,
    exclusions,
    warrantyterms,
    pricesummarytext,
    signaturetext,
  ) {
    let model = {
      method: "UpdateProjectQuoteSignatureApprovals",
      id: id,
      projectid: projectid,
      sowheader: sowheader == undefined ? "":sowheader,
      exclusions: exclusions,
      warrantyterms: warrantyterms,
      pricesummarytext: pricesummarytext,
      signaturetext: signaturetext,
    };

    console.log(model)
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  SalesProjectsBiders(projectid) {
    let model = {
      method: "Get_SalesProjectsBiders",
      projectid: projectid,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  UpdateScopeOfWork(systemid, scopeofwork, showinsow) {
    let model = {
      method: "UpdateScopeOfWork",
      scopeofwork: scopeofwork,
      systemid: systemid,
      showinswo: showinsow
    };

    console.log(model)
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  UpdateScopeOfWorkSC(systemid, scopeofwork, showinsow, estimateid) {
    let model = {
      method: "UpdatescScopeOfWork",
      scopeofwork: scopeofwork,
      systemid: systemid,
      showinswo: showinsow,
      estimateid:estimateid
    };

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  Get_EstimateSystemDocumentList() {
    let model = {
      method: "Get_EstimateSystemDocumentList"
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  InsertVisioDocument(id,systemid,name,documentrevision,description,revisionnotes,attachment,codename,locked,doctypeid,deleted) {
    let model = {
      method: "InsertVisioDocument",
      id: id,
      systemid: systemid,
      name: name,
      documentrevision: documentrevision,
      description: description,
      revisionnotes: revisionnotes,
      attachment: attachment,
      codename: codename,
      locked: locked == true ? 1:0,
      doctypeid: doctypeid,
      deleted: deleted == true ? 1:0,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  SaveImageSystem(filestring, id) {
    return this.http.post(this.BaseURI + '/DownloadFile/Upload', { filestring: filestring, doctype: 'systemsimg', id: id })
  }

  SaveImageProject(filestring, id) {
    return this.http.post(this.BaseURI + '/DownloadFile/Upload', { filestring: filestring, doctype: 'engimage', id: id })
  }

  SaveAttachment(filestring, id) {
    console.log(id)
    console.log(filestring)
    return this.http.post(this.BaseURI + '/DownloadFile/Upload', { filestring: filestring, doctype: 'systemsupload', id: id })
  }
  GetProcedureParameter(spname) {
    let model = {
      method: "GetProcedureXMLParameters",
      procedurename: spname,
    };


    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  duplicateImage(from, to){
    console.log(from)
    console.log(to)
    return this.http.post(this.BaseURI + '/DownloadFile/DuplicateSystem', { "from": from, "to" : to } )
  }





  Upadte_EstimateAreaSystemCELoc(
    id,
    systemid,
    sort,
    areaname,
    systemname,
    qty,
    systemtype,
    inactive,
    deleted,
    scopeofwork,
    sop,
    excludefromsearch,
    controldwgname,
    controldwgimg,
    tagtext,
    tagnum,
    description,
    location
  ) {
    let model = {
      method: "Upadte_EstimateAreaSystemCE-1",
      id: id,
      systemid: systemid,
      sort: sort,
      areaname: areaname,
      systemname: systemname,
      qty: qty,
      systemtype: systemtype,
      inactive: inactive,
      deleted: deleted,
      scopeofwork: scopeofwork,
      sop: sop,
      excludefromsearch: excludefromsearch,
      controldwgname: controldwgname,
      controldwgimg: controldwgimg == null ? "null" : controldwgimg,
      tagtext: tagtext,
      tagnum: tagnum,
      description: description,
      location:location
    };
    console.log(model)

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }

  GetSystemAreaShop(id, viewtypeid = 1) {
    return this.http.post<any>(this.BaseURI + "/FlexIntegration/CallExtFlex", {
      method: "Get_AreaSystemAllShop",
      estimateid: id,
      viewtypeid: viewtypeid
    });
  }

  Upadte_EstimateAreaSystemCEAreaidCubeShop(
    id,
    systemid,
    sort,
    areaname,
    areaid,
    systemname,
    qty,
    inactive,
  ) {
    let model = {
      method: "Upadte_EstimateAreaSystemSingleShop",
      id: id,
      systemid: systemid,
      sort: sort,
      areaname: areaname,
      areaid:areaid,
      systemname: systemname,
      qty: qty,
      inactive: inactive,
    };
    console.log(model)

    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


  Get_ActuatorDamper(val) {
    let model = {
      method: "Get_AccParts",
      partnamefilter: val,
    };
    return this.http.post<any>(this.BaseURI + this.apiroute, model);
  }


}